import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {I18n} from '@ngx-translate/i18n-polyfill';
import { UserImageModel, UserImageResponseModel, UserService as ApiUserService } from '@core/api';

export interface DialogData {
    code: string;
    operation_type: string;
}

@Component({
    selector: 'modal-confirmation-code',
    templateUrl: './modal-confirmation-code.component.html',
    styleUrls: ['./modal-confirmation-code.component.scss']
})
export class ModalConfirmationCodeComponent implements OnInit, OnDestroy {
    constructor(
        private i18n: I18n,
        public dialogRef: MatDialogRef<ModalConfirmationCodeComponent>,
        private apiUserService: ApiUserService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    confirm(code) {
        this.apiUserService.confirmUserConfirmationCode(code).subscribe(
            result => { }
        );
        this.dialogRef.close();
    }
}
